import { profile } from "@shared/api/services"
import { useQuery } from "@tanstack/react-query"


export const useResendEmailAvailable = (enabled) => {
	return useQuery({
		queryKey: ['resend-email-available'],
		queryFn: () => profile.getEmailResendAvailable(),
		enabled: !!enabled,
		select: data => data.data
	})
}